import { Row, Col } from "antd";
import PageHeader from "./PageHeader";
import ProductModal from "./ProductModal";
export default function Details({ data,modalData }) {
  return (
    <>
      <Row className="container">
        <Col span={22}>
          <PageHeader data={data} />
          <Col offset={4} span={18} style={{ marginTop: "1.5rem" }}>
            <ProductModal data={data} modalData={modalData} />
          </Col>
        </Col>
      </Row>
    </>
  );
}
